import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const StateEChallanBenefits = ({ challanBenefitsData = {} }) => {

    const { tokens } = useTokens();

    const { title = "", challanBenefitsList = [] } = challanBenefitsData || {};

    return (
        <div styleName={"styles.wrapper"}>
            <Text size="400" fontWeight="semibold" color={tokens.text_default_text_primary} as="h2">{title}</Text>
            <div styleName={"styles.listWrapper"}>
                {
                    challanBenefitsList.map(({ title: heading, description }, index) => (
                        <div styleName={"styles.listItem"} key={index}>
                            <Text size="250" fontWeight="semibold" color={tokens.text_default_text_primary}>{index + 1}.</Text>
                            <div styleName={"styles.listItemText"}>
                                <Text size="250" fontWeight="semibold" color={tokens.text_default_text_primary}>{heading}</Text>
                                <Text size="200" fontWeight="regular" color={tokens.text_default_text_secondary}>{description}</Text>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

StateEChallanBenefits.propTypes = {
    challanBenefitsData: PropTypes.object
};

export default StateEChallanBenefits;
